<div class="page-wrap">
  <!-- ── Header ──────────────────────────────────────────────────────── -->
  <div class="pinned">
    <div class="title">
      <nb-route-tabset [tabs]="tabs" [fullWidth]="true" [activeLinkOptions]="{exact: false}"></nb-route-tabset>
    </div>
    <div class="buttons">
      <div class="search-input">
        <nb-icon class="search-icon" icon="search-outline"></nb-icon>
        <input nbInput
               type="text"
               placeholder="{{ 'search.placeholder' | translate }}"
               [(ngModel)]="searchQuery"
               (ngModelChange)="onSearchChange($event)"
               fieldSize="small">
        @if (searchQuery) {
          <nb-icon class="clear-icon" icon="close-circle" (click)="clearSearch()"></nb-icon>
        }
      </div>

      <bst-table-options-button class="desktop-only" [count]="getActiveFilterCount()" (open)="openOptions()"></bst-table-options-button>

      <button *ngIf="canCreate" nbButton status="primary" size="small" type="button" (click)="openCreate()">
        <nb-icon icon="plus-outline"></nb-icon> {{ 'crm.new_opportunity' | translate }}
      </button>
    </div>
  </div>

  <div *ngIf="errorMessage" class="error-banner">{{ errorMessage }}</div>

  <bst-dual-axis [tag]="'crm_opportunities'" [delegate]="this" [pagingMode]="Globals.PagesMode"></bst-dual-axis>

  <ng-template #cellTemplate let-opp="row" let-column="column" let-node="node">
    @switch (column.name) {
      <!-- Opportunity -->
      @case ('opportunity') {
        <div class="opp-title-cell" (click)="openOpportunity(opp)">
          <div class="opp-title">{{ opp.title }}</div>
          <div class="opp-meta-line" *ngIf="opp.end_client?.name || opp.source === 'market'">
            <span class="opp-subtitle" *ngIf="opp.end_client?.name">{{ opp.end_client!.name }}</span>
            <span class="opp-caption" *ngIf="opp.source === 'market'">{{ 'crm.source.market' | translate }}</span>
          </div>
        </div>
      }

      <!-- Organization -->
      @case ('organization') {
        <span>{{ opp.end_client?.name || '—' }}</span>
      }

      <!-- Stage -->
      @case ('stage') {
        <span class="status-chip" [ngClass]="'is-' + opp.status">
          {{ ('crm.opp.' + opp.status) | translate }}
        </span>
        <nb-icon *ngIf="opp.status === 'archived' && opp.won_at"
                 icon="award-outline"
                 class="won-marker"
                 [nbTooltip]="'crm.opp.won' | translate">
        </nb-icon>
      }

      <!-- Rate -->
      @case ('rate') {
        <span class="tabular-nums">{{ formatValueRate(opp) }}</span>
      }

      <!-- Candidates: avatar cluster; empty when none. -->
      @case ('candidates') {
        @if (opp.submissions?.length) {
          <span class="candidate-cluster">
            @for (sub of opp.submissions.slice(0, 5); track sub.id) {
              <nb-user size="small"
                       [onlyPicture]="true"
                       [name]="consultantName(sub)"
                       [picture]="Globals.logo(sub.consultant)"
                       [nbTooltip]="consultantName(sub)"
                       class="candidate-avatar">
              </nb-user>
            }
            @if (opp.submissions.length > 5) {
              <span class="candidate-more" [nbTooltip]="overflowConsultantNames(opp)">+{{ opp.submissions.length - 5 }}</span>
            }
          </span>
        }
      }

      <!-- Owner -->
      @case ('owner') {
        <ng-container *ngIf="opp.owner as owner; else unassigned">
          <nb-user size="small"
                   [onlyPicture]="true"
                   [name]="ownerName(opp)"
                   [picture]="Globals.logo(owner)"
                   [nbTooltip]="ownerName(opp)">
          </nb-user>
        </ng-container>
        <ng-template #unassigned>
          <span class="owner-unassigned" [nbTooltip]="'crm.unassigned' | translate">—</span>
        </ng-template>
      }

      <!-- Deadline -->
      @case ('deadline') {
        <ng-container *ngIf="{ pastDue: deadlinePastDue(opp), rel: deadlineRelative(opp) } as d">
          <span [class.is-past-due]="d.pastDue">{{ formatDeadline(opp) }}</span>
          <span class="deadline-rel" *ngIf="d.rel" [class.is-past-due]="d.pastDue">{{ d.rel }}</span>
        </ng-container>
      }

      <!-- Last Activity -->
      @case ('activity') {
        <span class="muted">{{ formatLastActivity(opp) }}</span>
      }

      <!-- Default -->
      @default {
        <span>{{ opp[column.name] || '-' }}</span>
      }
    }
  </ng-template>

</div>
